module.exports = __webpack_public_path__ + "static/media/freshdesk-logo.6d602d85.svg";